import React, { useEffect, useState } from 'react';
import AutocompleteAddress from '../../Components/GooglePlacesAutoComplete/AutocompleteAddress';
import { useForm, Controller, useWatch } from 'react-hook-form';
import {
    Container,
    FormWrapper,
    FormHeader,
    FormContent,
    FormGroup,
    Label,
    Input,
    Select,
    TextArea,
    RadioGroup,
    RadioOption,
    CheckboxGroup,
    CheckboxOption,
    Button,
    ButtonGroup,
    VehicleGrid,
    VehicleCard,
    SectionTitle,
    FlexRow,
    FlexColumn,
    Tooltip
  } from './FormStyles';
   
import { useSelector } from 'react-redux';
import breakImage from '../../assets/img/CaptureBreak.png';
import f12Image from '../../assets/img/captureF12.png';
import f14Image from '../../assets/img/fourgon12m.png';
import c20Image from '../../assets/img/vehicule_camion.png';
import v75Image from '../../assets/img/7.5.png';
import tonnes12Image from '../../assets/img/tonnes12.png';
import tonnes19Image from '../../assets/img/tonnes19.png';
import tracteurActosImage from '../../assets/img/semi.png';
import semiImage from '../../assets/img/Capturesemi.png'

import tracteurImage from '../../assets/img/tracteur-actos.png'
import { useTranslation } from 'react-i18next';

// Valeurs par défaut constantes
const DEFAULT_VALUES = {
    name: '',
    adresse_debut: '',
    adresse_fin: '',
    kilometrage: '',
    taux_chargement: '15',
    notes: '',
    manutention_chauffeur: '',
    livraison: '',
    etage: 'RDC',
    escalier: false,
    ascenseur: false,
    poids_total: '',
    nature_chargement: '',
    nombre_palettes: '',
    nature_palettes: '',
    nombre_dimension: '',
    type_transport: '',
    type_transport_details: null,
    vehicule_poids_lourds: null,
    options_vehicule_leger: [],
    options_poids_lourds: [],
    danger: '',
    assurance: '',
    assurance_amount: '',
    nombre_rippeur: ''
};

// Fonction pour transformer les données du template vers le format du formulaire
const transformTemplateToFormData = (template) => {
  console.log('Template reçu pour transformation:', template);
  
  if (!template) return DEFAULT_VALUES;
  
  // Accéder aux champs depuis template.fields si c'est la structure
  const fields = template.fields || template;
  
  const transformedData = {
      name: template.name || '',
      adresse_debut: fields.adresse_debut || '',
      adresse_fin: fields.adresse_fin || '',
      kilometrage: fields.kilometrage?.toString() || '',
      taux_chargement: fields.taux_chargement?.toString() || '15',
      notes: fields.notes || '',
      // IMPORTANT: Convertir les booléens en chaînes pour les radio buttons
      manutention_chauffeur: fields.manutention_chauffeur === true ? 'true' : 
                            fields.manutention_chauffeur === false ? 'false' : '',
      livraison: fields.livraison || '',
      etage: fields.etage || 'RDC',
      escalier: fields.escalier === true,
      ascenseur: fields.ascenseur === true,
      poids_total: fields.poids_total?.toString() || '',
      nature_chargement: fields.nature_chargement || '',
      nombre_palettes: fields.nombre_palettes?.toString() || '',
      nature_palettes: fields.nature_palettes || '',
      nombre_dimension: fields.nombre_dimension?.toString() || '',
      type_transport: fields.type_transport || '',
      type_transport_details: fields.type_transport_details || null,
      vehicule_poids_lourds: fields.vehicule_poids_lourds || null,
      // CORRECTION: Créer de nouvelles références pour les tableaux
      options_vehicule_leger: Array.isArray(fields.options_vehicule_leger) 
        ? [...fields.options_vehicule_leger] 
        : [],
      options_poids_lourds: Array.isArray(fields.options_poids_lourds) 
        ? [...fields.options_poids_lourds] 
        : [],
      // Convertir les booléens pour les autres champs aussi
      danger: fields.danger === true ? 'true' : 
             fields.danger === false ? 'false' : '',
      assurance: fields.assurance === true ? 'true' : 
                fields.assurance === false ? 'false' : '',
      assurance_amount: fields.assurance_amount?.toString() || '',
      nombre_rippeur: fields.nombre_rippeur?.toString() || ''
  };
  
  console.log('Données transformées:', transformedData);
  console.log('Options véhicule léger:', transformedData.options_vehicule_leger);
  console.log('Options poids lourds:', transformedData.options_poids_lourds);
  
  return transformedData;
};

function MissionTemplateForm({
    cancelEdit,
    editingTemplate,
    onSave
}) {
     const {
            control,
            register,
            handleSubmit,
            watch,
            setValue,
            reset,
            formState: { errors }
        } = useForm({
            defaultValues: DEFAULT_VALUES
        });
        
        console.log('editingTemplate', editingTemplate);
    
        // Watch form values
        const user = useSelector((state) => state.auth.user)
        const isActiverRippeur = user?.activerRippeur
        const [isSubmitting, setIsSubmitting] = useState(false);
        const [submitError, setSubmitError] = useState(null);
        const [submitSuccess, setSubmitSuccess] = useState(false);
        const livraison = watch('livraison');
        const manutentionChauffeur = watch('manutention_chauffeur');
        const typeTransport = watch('type_transport');
        const natureChargement = watch('nature_chargement');
        const poidsTotal = watch('poids_total');
        const nombrePalettes = watch('nombre_palettes');
        const nombreDimension = watch('nombre_dimension');
        const typeTransportDetails = watch('type_transport_details');
        const vehiculePoidsLourds = watch('vehicule_poids_lourds');
        
        // CORRECTION: Utiliser directement les valeurs du formulaire
        const optionsVehiculeLeger = watch('options_vehicule_leger') || [];
        const optionsPoidsLourds = watch('options_poids_lourds') || [];
        
        const [isEtageDisabled, setIsEtageDisabled] = useState(false)
        const etage = watch('etage');
    
        // State variables
        const [isBreakDisabled, setIsBreakDisabled] = useState(false);
        const [isF12Disabled, setIsF12Disabled] = useState(false);
        const [isF14Disabled, setIsF14Disabled] = useState(false);
        const [isC20Disabled, setIsC20Disabled] = useState(false);
        const [isV75TDisabled, setIsV75TDisabled] = useState(false);
        const [is12TDisabled, setIs12TDisabled] = useState(false);
        const [is19TDisabled, setIs19TDisabled] = useState(false);
        const [isTracteurSemiDisabled, setIsTracteurSemiDisabled] = useState(false);
        const [isSemiDisabled, setIsSemiDisabled] = useState(false);
        const {t} = useTranslation();
        // Vehicle data with weight limits and capacity constraints
        const vehicleData = {
            leger: [
                { id: 'Break', name: t("break"), capacity: '1097 kg', image: breakImage, limit: 1097, paletteLimit: 2, vracLimit: 6 },
                { id: 'Fourgon 12m³', name: `${t("fourgon")} 12m³`, capacity: '1244 kg', image:f12Image, limit: 1244, paletteLimit: 5, vracLimit: 12 },
                { id: 'Fourgon 14m³', name: `${t("fourgon")} 14m³`, capacity: '1353 kg', image: f14Image, limit: 1353, paletteLimit: 6, vracLimit: 14 },
                { id: 'Camion 20m³', name: `${t("camion")} 20m³`, capacity: '1200 kg', image: c20Image, limit: 1200, paletteLimit: 7, vracLimit: 20 }
            ],
            lourd: [
                { id: '7,5 Tonnes', name: '7,5 Tonnes', capacity: '2470 kg', image: v75Image, limit: 2470, paletteLimit: 16, vracLimit: 30 },
                { id: '12 Tonnes', name: '12 Tonnes', capacity: '5600 kg', image: tonnes12Image, limit: 5600, paletteLimit: 19, vracLimit: 45 },
                { id: '19 Tonnes', name: '19 Tonnes', capacity: '9200 kg', image: tonnes19Image, limit: 9200, paletteLimit: 22, vracLimit: 58 },
                { id: 'Semi', name: t("semi"), capacity: '27000 kg', image: semiImage, limit: 27000, paletteLimit: 33, vracLimit: 86 },
                { id: 'Tracteur+semi', name: t("tractor_semi"), capacity: '27000 kg', image: tracteurActosImage, limit: 27000, paletteLimit: 33, vracLimit: 86 },
                { id: 'Tracteur', name: t("tractor"), capacity: t("unlimited"), image: tracteurImage, limit: Infinity, paletteLimit: Infinity, vracLimit: 6 }
            ]
        };
    
        const transportOptionsLeger = ['Frigorifique', 'Tall', 'Hayon'];
        const transportOptionsLourd = ['Bachée', 'Frigorifique', 'Hayon', 'Tall'];
        const renderVehicleOption = (option) => {
        switch (option) {
            case "Frigorifique":
                return t("refrigerated");
            case "Bachée":
                return t("tarped");
            case "Hayon":
                return t("liftgate");
            default:
                return option;
        }
    };
    
        // Weight and capacity compatibility check
        const checkCompatibility = (vehicleId, totalWeight, quantity, nature) => {
            const allVehicles = [...vehicleData.leger, ...vehicleData.lourd];
            const vehicle = allVehicles.find(v => v.id === vehicleId);
            
            if (!vehicle) return false;
            
            const weightExceeded = totalWeight > vehicle.limit;
            let quantityExceeded = false;
            
            if (nature === 'palette' && quantity > 0) {
                quantityExceeded = quantity > vehicle.paletteLimit;
            } else if (nature === 'vrac' && quantity > 0) {
                quantityExceeded = quantity > vehicle.vracLimit;
            }
            
            return !weightExceeded && !quantityExceeded;
        };
    
        // CORRECTION: Simplifier la gestion des options
        const handleOptionChange = (optionType, value, checked) => {
            console.log(`Changement d'option: ${optionType}, ${value}, ${checked}`);
            
            const fieldName = optionType === 'leger' ? 'options_vehicule_leger' : 'options_poids_lourds';
            const currentOptions = optionType === 'leger' ? optionsVehiculeLeger : optionsPoidsLourds;
            
            console.log('Options actuelles:', currentOptions);
            
            let updatedOptions;
            
            if (checked) {
                updatedOptions = [...currentOptions, value];
                
                // Handle mutual exclusivity for Bachée and Frigorifique
                if (value === 'Bachée' || value === 'Frigorifique') {
                    const otherOption = value === 'Bachée' ? 'Frigorifique' : 'Bachée';
                    updatedOptions = updatedOptions.filter(option => option !== otherOption);
                }
            } else {
                updatedOptions = currentOptions.filter(option => option !== value);
            }
            
            console.log('Nouvelles options:', updatedOptions);
            setValue(fieldName, updatedOptions);
        };
    
        // Handle vehicle selection
        const handleVehicleSelect = (vehicleId, vehicleType) => {
            const totalWeight = Number(poidsTotal) || 0;
            const quantity = natureChargement === 'palette' ? Number(nombrePalettes) || 0 : Number(nombreDimension) || 0;
            
            if ((totalWeight > 0 || quantity > 0) && !checkCompatibility(vehicleId, totalWeight, quantity, natureChargement)) {
                alert(t("vehicle_cannot_support_weight"));
                return;
            }
    
            if (vehicleType === 'leger') {
                setValue('type_transport_details', vehicleId);
                setValue('vehicule_poids_lourds', undefined);
                setValue('type_transport', 'Véhicule léger');
                setValue('options_poids_lourds', []);
            } else {
                setValue('vehicule_poids_lourds', vehicleId);
                setValue('type_transport_details', undefined);
                setValue('type_transport', 'Poids lourds');
                setValue('options_vehicule_leger', []);
            }
        };
    
        // Update vehicle availability based on constraints
        const updateVehicleAvailability = () => {
            const totalWeight = Number(poidsTotal) || 0;
            const quantity = natureChargement === 'palette' ? Number(nombrePalettes) || 0 : Number(nombreDimension) || 0;
    
            setIsBreakDisabled(!checkCompatibility('Break', totalWeight, quantity, natureChargement));
            setIsF12Disabled(!checkCompatibility('Fourgon 12m³', totalWeight, quantity, natureChargement));
            setIsF14Disabled(!checkCompatibility('Fourgon 14m³', totalWeight, quantity, natureChargement));
            setIsC20Disabled(!checkCompatibility('Camion 20m³', totalWeight, quantity, natureChargement));
            setIsV75TDisabled(!checkCompatibility('7,5 Tonnes', totalWeight, quantity, natureChargement));
            setIs12TDisabled(!checkCompatibility('12 Tonnes', totalWeight, quantity, natureChargement));
            setIs19TDisabled(!checkCompatibility('19 Tonnes', totalWeight, quantity, natureChargement));
            setIsSemiDisabled(!checkCompatibility('Semi', totalWeight, quantity, natureChargement));
            setIsTracteurSemiDisabled(!checkCompatibility('Tracteur+semi', totalWeight, quantity, natureChargement));
        };
        
        const onSubmit = async (data) => {
            setIsSubmitting(true);
            setSubmitError(null);
            setSubmitSuccess(false);
          
            try {
              // Préparer les données selon le format attendu par l'API
              const templateData = {
                name: data.name,
                fields: {
                  adresse_debut: data.adresse_debut,
                  adresse_fin: data.adresse_fin,
                  kilometrage: data.kilometrage,
                  taux_chargement: data.taux_chargement,
                  notes: data.notes,
                  manutention_chauffeur: data.manutention_chauffeur,
                  livraison: data.livraison,
                  etage: data.etage,
                  escalier: data.escalier,
                  ascenseur: data.ascenseur,
                  poids_total: data.poids_total,
                  nature_chargement: data.nature_chargement,
                  nombre_palettes: data.nombre_palettes,
                  nature_palettes: data.nature_palettes,
                  nombre_dimension: data.nombre_dimension,
                  type_transport: data.type_transport,
                  type_transport_details: data.type_transport_details,
                  vehicule_poids_lourds: data.vehicule_poids_lourds,
                  options_vehicule_leger: data.options_vehicule_leger,
                  options_poids_lourds: data.options_poids_lourds,
                  danger: data.danger,
                  assurance: data.assurance,
                  nombre_rippeur: data?.nombre_rippeur,
                  assurance_amount: data?.assurance_amount
                }
              };
          
              // Utiliser la fonction onSave passée en prop
              await onSave(templateData);
              
              setSubmitSuccess(true);
              setTimeout(() => {
                setSubmitSuccess(false);
              }, 3000);
          
            } catch (error) {
              setSubmitError(
                error.message || 'Une erreur est survenue lors de la sauvegarde du template'
              );
            } finally {
              setIsSubmitting(false);
            }
        };
    
        // Effects for form validation and dependencies
        useEffect(() => {
            updateVehicleAvailability();
            
            // Clear invalid vehicle selections
            const totalWeight = Number(poidsTotal) || 0;
            const quantity = natureChargement === 'palette' ? Number(nombrePalettes) || 0 : Number(nombreDimension) || 0;
            
            if (typeTransportDetails && !checkCompatibility(typeTransportDetails, totalWeight, quantity, natureChargement)) {
                setValue('type_transport_details', undefined);
                setValue('type_transport', '');
            }
            
            if (vehiculePoidsLourds && !checkCompatibility(vehiculePoidsLourds, totalWeight, quantity, natureChargement)) {
                setValue('vehicule_poids_lourds', undefined);
                setValue('type_transport', '');
            }
        }, [poidsTotal, nombrePalettes, nombreDimension, natureChargement]);
    
        useEffect(() => {
            if (livraison && livraison !== 'Domicile/Batiment/Maison') {
                setValue('etage', 'RDC');
                setValue('escalier', false);
                setValue('ascenseur', false);
            }
        }, [livraison]);
        
        useEffect(() => {
            const isNonChauffeurHandling = watch('manutention_chauffeur')
            const nombreRippeur = watch('nombre_rippeur')
    
            if (isActiverRippeur) {
                setIsEtageDisabled(
                    isNonChauffeurHandling === 'false' && nombreRippeur <= 0
                )
                if (isNonChauffeurHandling === 'false' && nombreRippeur <= 0) {
                    setValue('etage', 'RDC')
                    setValue('escalier', '')
                    setValue('ascenseur', '')
                }
            } else {
                setIsEtageDisabled(isNonChauffeurHandling === 'false')
                if (isNonChauffeurHandling === 'false') {
                    setValue('etage', 'RDC')
                    setValue('escalier', false)
                    setValue('ascenseur', false)
                }
            }
    
            if (isNonChauffeurHandling === 'true' || nombreRippeur > 0) {
                setIsEtageDisabled(false)
            }
    
            // Disable escalier and ascenseur when RDC is selected
            const currentEtage = watch('etage')
            if (currentEtage === 'RDC') {
                setValue('escalier', false)
                setValue('ascenseur', false)
            }
        }, [
            watch('manutention_chauffeur'),
            watch('nombre_rippeur'),
            watch('etage'),
        ])
        
        useEffect(() => {
            if (natureChargement === 'palette') {
                setValue('nombre_dimension', '');
            } else if (natureChargement === 'vrac') {
                setValue('nombre_palettes', '');
                setValue('nature_palettes', '');
            }
        }, [natureChargement]);
    
        useEffect(() => {
            if (typeTransport === 'Véhicule léger') {
                setValue('vehicule_poids_lourds', '');
                setValue('options_poids_lourds', []);
            } else if (typeTransport === 'Poids lourds') {
                setValue('type_transport_details', '');
                setValue('options_vehicule_leger', []);
            }
        }, [typeTransport]);
    
        // Disable escalier and ascenseur when RDC is selected
        useEffect(() => {
            if (etage === 'RDC') {
                setValue('escalier', false);
                setValue('ascenseur', false);
            }
        }, [etage]);
    
        const isVehicleDisabled = (vehicle, vehicleType) => {
            const totalWeight = Number(poidsTotal) || 0;
            const quantity = natureChargement === 'palette' ? Number(nombrePalettes) || 0 : Number(nombreDimension) || 0;
            return !checkCompatibility(vehicle.id, totalWeight, quantity, natureChargement);
        };

        // CORRECTION: Effet principal pour la réinitialisation
        useEffect(() => {
            console.log('Effet de réinitialisation déclenché, editingTemplate:', editingTemplate);
            
            if (editingTemplate) {
                const formData = transformTemplateToFormData(editingTemplate);
                console.log('Réinitialisation avec les données du template:', formData);
                
                // Utiliser setTimeout pour s'assurer que la réinitialisation se fait après le rendu
                setTimeout(() => {
                    reset(formData);
                    console.log('Formulaire réinitialisé');
                }, 0);
            } else {
                console.log('Réinitialisation avec les valeurs par défaut');
                setTimeout(() => {
                    reset(DEFAULT_VALUES);
                    console.log('Formulaire réinitialisé avec valeurs par défaut');
                }, 0);
            }
        }, [editingTemplate, reset]);

        // Debug: Afficher les valeurs actuelles des options
        useEffect(() => {
            console.log('Options véhicule léger actuelles:', optionsVehiculeLeger);
            console.log('Options poids lourds actuelles:', optionsPoidsLourds);
        }, [optionsVehiculeLeger, optionsPoidsLourds]);
        const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
	
		useEffect(() => {
			const checkScreen = () => {
				const width = window.innerWidth;
	
				setIsMobile(width < 768);
	
			};
			checkScreen();
			window.addEventListener('resize', checkScreen);
	
			return () => window.removeEventListener('resize', checkScreen);
		}, []);

    return (
        <Container>
        <form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>
                <Label>{t("template_name")} <span className="required">*</span></Label>
                <Controller
                    name="name"
                    control={control}
                    rules={{ required: t("template_name_required") }}
                    render={({ field }) => (
                    <Input
                     {...field}
                     placeholder={t("template_name_placeholder")}
                    />
                    )}
                />
                {errors.name && (
                     <div style={{ color: 'red', marginTop: '0.5rem' }}>
                       {errors.name.message}
                     </div>
                 )}
            </FormGroup>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
               
                <FormGroup>
                    <Label>{t("start_address")} <span className="required">*</span></Label>
                    <Controller
                         name="adresse_debut"
                         control={control}
                         rules={{ required: t("start_address_required") }}
                         render={({ field: { onChange, value } }) => (
                                <AutocompleteAddress
                                    onPlaceSelect={(placeDetails) => {
                                    console.log('Place ID:', placeDetails.place_id);
                                    }}
                                    onValueChange={onChange}
                                    value={value}
                                    placeholder={t("location_placeholder")}
                                />
                           )}
                     />
                    {errors.adresse_debut && (
                       <div style={{ color: 'red', marginTop: '0.5rem' }}>
                        {errors.adresse_debut.message}
                   </div>
                  )}
                 </FormGroup>
                 <FormGroup>
                    <Label>{t("end_address")} <span className="required">*</span></Label>
                    <Controller
                        name="adresse_fin"
                        control={control}
                        rules={{ required: t("end_address_required") }}
                        render={({ field: { onChange, value } }) => (
                            <AutocompleteAddress
                                onValueChange={onChange}
                                value={value}
                                placeholder={t("location_placeholder")}
                            />
                        )}
                    />
                    {errors.adresse_fin && (
                        <div style={{ color: 'red', marginTop: '0.5rem' }}>
                            {errors.adresse_fin.message}
                        </div>
                    )}
                </FormGroup>
            </div>

            <FlexRow>
                <FlexColumn>
                    <FormGroup>
                        <Label>{t("mileage")} <span className="required">*</span></Label>
                        <Controller
                            name="kilometrage"
                            control={control}
                            rules={{ required: t("mileage_required") }}
                            render={({ field }) => (
                                <Select {...field}>
                                    <option value="">{t("select")}</option>
                                    <option value="200">200 km</option>
                                    <option value="300">300 km</option>
                                    <option value="400">400 km</option>
                                </Select>
                            )}
                        />
                        {errors.kilometrage && (
                            <div style={{ color: 'red', marginTop: '0.5rem' }}>
                                {errors.kilometrage.message}
                            </div>
                        )}
                    </FormGroup>
                </FlexColumn>
                
                <FlexColumn>
                    <FormGroup>
                        <Label>{t("loading_time")} <span className="required">*</span></Label>
                        <Controller
                            name="taux_chargement"
                            control={control}
                            rules={{ required: t("loading_time_required") }}
                            render={({ field }) => (
                                <Select {...field}>
                                    <option value="10">10 min</option>
                                    <option value="15">15 min</option>
                                    <option value="20">20 min</option>
                                    <option value="25">25 min</option>
                                    <option value="30">30 min</option>
                                </Select>
                            )}
                        />
                        {errors.taux_chargement && (
                            <div style={{ color: 'red', marginTop: '0.5rem' }}>
                                {errors.taux_chargement.message}
                            </div>
                        )}
                    </FormGroup>
                </FlexColumn>
            </FlexRow>

            <FormGroup>
                <Label>{t("standard_notes")}</Label>
                <Controller
                    name="notes"
                    control={control}
                    render={({ field }) => (
                        <TextArea
                            {...field}
                            placeholder={t("add_note_here")}
                        />
                    )}
                />
            </FormGroup>

            <FormGroup>
        <Label>{t("driver_handling")} <span className="required">*</span></Label>
        <RadioGroup>
          <Controller
            name="manutention_chauffeur"
            control={control}
            rules={{ required: t("driver_handling_required") }}
            render={({ field }) => (
              <>
                <RadioOption 
                  className={field.value === 'true' ? 'selected' : ''}
                  onClick={() => field.onChange('true')}
                >
                  <input
                    type="radio"
                    {...field}
                    value="true"
                    checked={field.value === 'true'}
                    readOnly
                  />
                  <label>{t("yes")}</label>
                </RadioOption>
                <RadioOption 
                  className={field.value === 'false' ? 'selected' : ''}
                  onClick={() => field.onChange('false')}
                >
                  <input
                    type="radio"
                    {...field}
                    value="false"
                    checked={field.value === 'false'}
                    readOnly
                  />
                  <label>{t("no")}</label>
                </RadioOption>
              </>
            )}
          />
        </RadioGroup>
        {errors.manutention_chauffeur && (
          <div style={{ color: 'red', marginTop: '0.5rem' }}>
            {errors.manutention_chauffeur.message}
          </div>
        )}
      </FormGroup>
            
            {isActiverRippeur &&
          <FormGroup>
          <Label>{t("nombre_rippeur")}</Label>
          <Controller
            name="nombre_rippeur"
            defaultValue={0}
            control={control}
            rules={{
              min: { value: 0, message: t("nombre_rippeur_err1") },
              max: { value: 2, message: t("nombre_rippeur_err2") },
            }}
            render={({ field }) => (
              <Input
                type="number"
                {...field}
                min="0"
                max="2"
                onInput={(e) => {
                  const value = parseInt(e.target.value, 10);
                  if (value > 2) {
                    e.target.value = 2;
                    field.onChange(2); // met à jour le state avec 2 si valeur dépassée
                  } else {
                    field.onChange(e); // gère la saisie normale
                  }
                }}
                placeholder={t("enter_loaders_number")}
              />
            )}
          />
          {errors.nombre_rippeur && (
            <div style={{ color: 'red', marginTop: '0.5rem' }}>
              {errors.nombre_rippeur.message}
            </div>
          )}
        </FormGroup>
        
            }
            
            <FormGroup>
                <Label>{t("delivery_location")} <span className="required">*</span></Label>
                <RadioGroup>
                    <RadioOption 
                      className={livraison === 'Entrepot/Magasin/Chantier' ? 'selected' : ''}
                      onClick={() => setValue('livraison', 'Entrepot/Magasin/Chantier')}
                     >
                        <Controller
                            name="livraison"
                            control={control}
                            rules={{ required: t("delivery_location_required") }}
                            render={({ field }) => (
                                <input
                                    type="radio"
                                    {...field}
                                    value="Entrepot/Magasin/Chantier"
                                    checked={field.value === 'Entrepot/Magasin/Chantier'}
                                />
                            )}
                        />
                        <label>{t("pickup_point1")}</label>
                    </RadioOption>
                    <RadioOption 
                     className={livraison === 'Domicile/Batiment/Maison' ? 'selected' : ''}
                     onClick={() => setValue('livraison', 'Domicile/Batiment/Maison')}
                    >
                        <Controller
                            name="livraison"
                            control={control}
                            rules={{ required: t("delivery_location_required") }}
                            render={({ field }) => (
                                <input
                                    type="radio"
                                    {...field}
                                    value="Domicile/Batiment/Maison"
                                    checked={field.value === 'Domicile/Batiment/Maison'}
                                />
                            )}
                        />
                        <label>{t("pickup_point2")}</label>
                    </RadioOption>
                </RadioGroup>
                {errors.livraison && (
                    <div style={{ color: 'red', marginTop: '0.5rem' }}>
                        {errors.livraison.message}
                    </div>
                )}
            </FormGroup>

            {livraison === 'Domicile/Batiment/Maison' && (
                <FlexRow align="flex-end" style={{
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    }}>
                    <  FlexColumn flex="2">
                        <FormGroup>
                            <Label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {t("floor")}
                            </Label>
                            <Controller
                                name="etage"
                                control={control}
                                render={({ field }) => (
                                    <Select {...field}
                                     disabled={isEtageDisabled}
                                    >
                                        <option value="RDC">{t("ground_floor")}</option>
                                        <option value="1-10">1-10</option>
                                        <option value="11-20">11-20</option>
                                        <option value="21-30">21-30</option>
                                    </Select>
                                )}
                            />
                        </FormGroup>
                    </FlexColumn>
                    
                    {etage !== 'RDC' && !isEtageDisabled && (
                    <FlexColumn flex="1">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '1rem',
                      }}
                    >
                      <CheckboxOption
                        className={watch('escalier') ? 'selected' : ''}
                        onClick={() => setValue('escalier', !watch('escalier'))}
                      >
                        <Controller
                          name="escalier"
                          control={control}
                          render={({ field: { onChange, value } }) => (
                            <input
                              type="checkbox"
                              checked={value || false}
                              onChange={(e) => {
                                e.stopPropagation(); // évite conflit avec onClick parent
                                onChange(e.target.checked);
                              }}
                              style={{ pointerEvents: 'none' }}
                            />
                          )}
                        />
                        <label>{t("stairs")}</label>
                      </CheckboxOption>
                  
                      <CheckboxOption
                        className={watch('ascenseur') ? 'selected' : ''}
                        onClick={() => setValue('ascenseur', !watch('ascenseur'))}
                      >
                        <Controller
                          name="ascenseur"
                          control={control}
                          render={({ field: { onChange, value } }) => (
                            <input
                              type="checkbox"
                              checked={value || false}
                              onChange={(e) => {
                                e.stopPropagation();
                                onChange(e.target.checked);
                              }}
                              style={{ pointerEvents: 'none' }}
                            />
                          )}
                        />
                        <label>{t("elevator")}</label>
                      </CheckboxOption>
                    </div>
                  </FlexColumn>
                  
    )}
                </FlexRow>
            )}

            <FormGroup>
                <Label>{t("total_weight")} (kg) <span className="required">*</span></Label>
                <Controller
                    name="poids_total"
                    control={control}
                    rules={{ 
                        required: t("total_weight_required"),
                        min: { value: 0, message: t("total_weight_err1") }
                    }}
                    render={({ field }) => (
                        <Input
                            type="number"
                            {...field}
                            min="0"
                            placeholder={t("enter_total_weight")}
                        />
                    )}
                />
                {errors.poids_total && (
                    <div style={{ color: 'red', marginTop: '0.5rem' }}>
                        {errors.poids_total.message}
                    </div>
                )}
            </FormGroup>

            <FormGroup>
                <Label>{t("load_type")} <span className="required">*</span></Label>
                <RadioGroup>
                    <RadioOption 
                     className={natureChargement === 'vrac' ? 'selected' : ''}
                     onClick={() => setValue('nature_chargement', 'vrac')}                    >
                        <Controller
                            name="nature_chargement"
                            control={control}
                            rules={{ required: t("nature_of_load_required") }}
                            render={({ field }) => (
                                <input
                                    type="radio"
                                    {...field}
                                    value="vrac"
                                    checked={field.value === 'vrac'}
                                />
                            )}
                        />
                        <label>{t("bulk")}</label>
                    </RadioOption>
                    <RadioOption 
                          className={natureChargement === 'palette' ? 'selected' : ''}
                          onClick={() => setValue('nature_chargement', 'palette')}
                    >
                        <Controller
                            name="nature_chargement"
                            control={control}
                            rules={{ required: t("nature_of_load_required") }}
                            render={({ field }) => (
                                <input
                                    type="radio"
                                    {...field}
                                    value="palette"
                                    checked={field.value === 'palette'}
                                />
                            )}
                        />
                        <label>{t("pallet")}</label>
                    </RadioOption>
                </RadioGroup>
                {errors.nature_chargement && (
                    <div style={{ color: 'red', marginTop: '0.5rem' }}>
                        {errors.nature_chargement.message}
                    </div>
                )}
            </FormGroup>

            {natureChargement === 'palette' && (
                <>
                    <FormGroup>
                        <Label>{t("number_of_pallets")} <span className="required">*</span></Label>
                        <Controller
                            name="nombre_palettes"
                            control={control}
                            rules={{ required: t("number_of_pallets_required") }}
                            render={({ field }) => (
                                <Input
                                    type="number"
                                    {...field}
                                    min="1"
                                    placeholder={t("number_of_pallets")}
                                />
                            )}
                        />
                        {errors.nombre_palettes && (
                            <div style={{ color: 'red', marginTop: '0.5rem' }}>
                                {errors.nombre_palettes.message}
                            </div>
                        )}
                    </FormGroup>
                    <FormGroup>
                        <Label>{t("pallets_type")} <span className="required">*</span></Label>
                        <Controller
                            name="nature_palettes"
                            control={control}
                            rules={{ required: t("type_of_pallets_required") }}
                            render={({ field }) => (
                                <TextArea
                                    {...field}
                                    placeholder={t("pallet_nature")}
                                />
                            )}
                        />
                        {errors.nature_palettes && (
                            <div style={{ color: 'red', marginTop: '0.5rem' }}>
                                {errors.nature_palettes.message}
                            </div>
                        )}
                    </FormGroup>
                </>
            )}

            {natureChargement === 'vrac' && (
                <FormGroup>
                    <Label>{t("number_of_dimensions")} type (m³)</Label>
                    <Controller
                        name="nombre_dimension"
                        control={control}
                        render={({ field }) => (
                            <Input
                                type="number"
                                {...field}
                                min="1"
                                placeholder={`Volume ${t("in")} m³`}
                            />
                        )}
                    />
                </FormGroup>
            )}

            <SectionTitle>{t("transport_type")}</SectionTitle>
            
            <FormGroup>
                <Label>{t("transport_type")} <span className="required">*</span></Label>
                <RadioGroup>
                    <RadioOption 
                     className={typeTransport === 'Véhicule léger' ? 'selected' : ''}
                     onClick={() => setValue('type_transport', 'Véhicule léger')}>
                        <Controller
                            name="type_transport"
                            control={control}
                            rules={{ required: t("transport_type_required") }}
                            render={({ field }) => (
                                <input
                                    type="radio"
                                    {...field}
                                    value="Véhicule léger"
                                    checked={field.value === 'Véhicule léger'}
                                />
                            )}
                        />
                        <label>{t("vehicle_type2")}</label>
                    </RadioOption>
                    <RadioOption
                     className={typeTransport === 'Poids lourds' ? 'selected' : ''}
                     onClick={() => setValue('type_transport', 'Poids lourds')}
                    >
                        <Controller
                            name="type_transport"
                            control={control}
                            rules={{ required: t("transport_type_required") }}
                            render={({ field }) => (
                                <input
                                    type="radio"
                                    {...field}
                                    value="Poids lourds"
                                    checked={field.value === 'Poids lourds'}
                                />
                            )}
                        />
                        <label>{t("vehicle_type1")}</label>
                    </RadioOption>
                </RadioGroup>
                {errors.type_transport && (
                    <div style={{ color: 'red', marginTop: '0.5rem' }}>
                        {errors.type_transport.message}
                    </div>
                )}
            </FormGroup>

            {typeTransport === 'Véhicule léger' && (
                <>
                    <FormGroup>
                        <Label>{t("vehicle_type2")} <span className="required">*</span></Label>
                        <VehicleGrid>
                            {vehicleData.leger.map(vehicle => (
                                <VehicleCard
                                    key={vehicle.id}
                                    className={`
                                        ${typeTransportDetails === vehicle.id ? 'selected' : ''}
                                        ${isVehicleDisabled(vehicle, 'leger') ? 'disabled' : ''}
                                    `}
                                    onClick={() => !isVehicleDisabled(vehicle, 'leger') && handleVehicleSelect(vehicle.id, 'leger')}
                                >
                                    <img src={vehicle.image} alt={vehicle.name} />
                                    <div className="vehicle-name">{vehicle.name}</div>
                                    <div className="vehicle-capacity">
                                     <div>{vehicle.capacity}</div>
                                      <div>{t("bulk")}: {vehicle.vracLimit}M3</div>
                                      <div>{t("pallet")}: {vehicle.paletteLimit}pal europe</div>
                                    </div>
                                </VehicleCard>
                            ))}
                        </VehicleGrid>
                        {errors.type_transport_details && (
                            <div style={{ color: 'red', marginTop: '0.5rem' }}>
                                {t("select_light_vehicle")}
                            </div>
                        )}
                    </FormGroup>

                    <FormGroup>
  <Label>{t("light_vehicle_options")}<span className="required">*</span></Label>
  <CheckboxGroup>
    {transportOptionsLeger.map(option => {
      const isSelected = optionsVehiculeLeger.includes(option);
      return (
        <CheckboxOption
          key={option}
          className={isSelected ? 'selected' : ''}
          onClick={() => handleOptionChange('leger', option, !isSelected)}
        >
          <input
            type="checkbox"
            value={option}
            checked={isSelected}
            onChange={(e) => {
              e.stopPropagation(); // évite double toggle
              handleOptionChange('leger', option, e.target.checked);
            }}
            style={{ pointerEvents: 'none' }}
          />
          <label>{renderVehicleOption(option)}</label>
        </CheckboxOption>
      );
    })}

    {typeTransportDetails === 'Camion 20m³' && (
      <CheckboxOption
        key="Bachée"
        className={optionsVehiculeLeger.includes('Bachée') ? 'selected' : ''}
        onClick={() =>
          handleOptionChange('leger', 'Bachée', !optionsVehiculeLeger.includes('Bachée'))
        }
      >
        <input
          type="checkbox"
          value="Bachée"
          checked={optionsVehiculeLeger.includes('Bachée')}
          onChange={(e) => {
            e.stopPropagation();
            handleOptionChange('leger', 'Bachée', e.target.checked);
          }}
          style={{ pointerEvents: 'none' }}
        />
        <label>{t("tarped")}</label>
      </CheckboxOption>
    )}
  </CheckboxGroup>

  {errors.options_vehicule_leger && (
    <div style={{ color: 'red', marginTop: '0.5rem' }}>
      {t("select_at_least_one_option")}
    </div>
  )}
</FormGroup>

                </>
            )}

            {typeTransport === 'Poids lourds' && (
                <>
                    <FormGroup>
                        <Label>{t("vehicle_type1")} <span className="required">*</span></Label>
                        <VehicleGrid>
                            {vehicleData.lourd.map(vehicle => (
                                <VehicleCard
                                    key={vehicle.id}
                                    className={`
                                        ${vehiculePoidsLourds === vehicle.id ? 'selected' : ''}
                                        ${isVehicleDisabled(vehicle, 'lourd') ? 'disabled' : ''}
                                    `}
                                    onClick={() => !isVehicleDisabled(vehicle, 'lourd') && handleVehicleSelect(vehicle.id, 'lourd')}
                                >
                                    <img src={vehicle.image} alt={vehicle.name} />
                                    <div className="vehicle-name">{vehicle.name}</div>
                                    <div className="vehicle-capacity">
                                     <div>{vehicle.capacity}</div>
                                     <div>{t("bulk")}: {vehicle.vracLimit}M3</div>
                                     <div>{t("pallet")}: {vehicle.paletteLimit}pal europe</div>
                                   </div>
                                </VehicleCard>
                            ))}
                        </VehicleGrid>
                        {errors.vehicule_poids_lourds && (
                            <div style={{ color: 'red', marginTop: '0.5rem' }}>
                                {t("select_heavy_vehicle")}
                            </div>
                        )}
                    </FormGroup>

                    <FormGroup>
  <Label>{t("heavy_truck_options")} <span className="required">*</span></Label>
  <CheckboxGroup>
    {transportOptionsLourd.map(option => {
      const isSelected = optionsPoidsLourds.includes(option);

      return (
        <CheckboxOption
          key={option}
          className={isSelected ? 'selected' : ''}
          onClick={() => handleOptionChange('lourd', option, !isSelected)}
        >
          <input
            type="checkbox"
            value={option}
            checked={isSelected}
            onChange={(e) => {
              e.stopPropagation(); // pour éviter le double toggle
              handleOptionChange('lourd', option, e.target.checked);
            }}
            style={{ pointerEvents: 'none' }}
          />
          <label>{renderVehicleOption(option)}</label>
        </CheckboxOption>
      );
    })}
  </CheckboxGroup>

  {errors.options_poids_lourds && (
    <div style={{ color: 'red', marginTop: '0.5rem' }}>
      {t("select_at_least_one_option")}
    </div>
  )}
</FormGroup>

                </>
            )}

            <SectionTitle>{t("additional_options")}</SectionTitle>

            <FormGroup>
                <Label>{t("hazardous_materials")} <span className="required">*</span></Label>
                <RadioGroup>
                  <RadioOption 
                   className={watch('danger') === 'true' ? 'selected' : ''}
                   onClick={() => setValue('danger', 'true')}                  >
                    <Controller
                      name="danger"
                      control={control}
                      render={({ field }) => (
                        <input
                          type="radio"
                          {...field}
                          value="true"
                          checked={field.value === 'true'}
                        />
                      )}
                    />
                    <label>{t("yes")}</label>
                  </RadioOption>
                  <RadioOption 
                   className={watch('danger') === 'false' ? 'selected' : ''}
                   onClick={() => setValue('danger', 'false')}>
                    <Controller
                      name="danger"
                      control={control}
                      render={({ field }) => (
                        <input
                          type="radio"
                          {...field}
                          value="false"
                          checked={field.value === 'false'}
                        />
                      )}
                    />
                    <label>{t("no")}</label>
                  </RadioOption>
                </RadioGroup>
            </FormGroup>
            
            <FormGroup>
                <Label>{t("insurance")} <span className="required">*</span></Label>
                <RadioGroup>
                  <RadioOption 
                   className={watch('assurance') === 'true' ? 'selected' : ''}
                   onClick={() => setValue('assurance', 'true')}                  >
                    <Controller
                      name="assurance"
                      control={control}
                      render={({ field }) => (
                        <input
                          type="radio"
                          {...field}
                          value="true"
                          checked={field.value === 'true'}
                        />
                      )}
                    />
                    <label>{t("yes")}</label>
                  </RadioOption>
                  <RadioOption 
                   className={watch('assurance') === 'false' ? 'selected' : ''}
                   onClick={() => setValue('assurance', 'false')}>
                    <Controller
                      name="assurance"
                      control={control}
                      render={({ field }) => (
                        <input
                          type="radio"
                          {...field}
                          value="false"
                          checked={field.value === 'false'}
                        />
                      )}
                    />
                    <label>{t("no")}</label>
                  </RadioOption>
                </RadioGroup>
            </FormGroup>

            {watch('assurance') === 'true' && (
              <div style={{ marginTop: '20px', width: '100%' }}>
                <FormGroup>
                  <Label style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                    {t("insurance_amount")} <span className="required">*</span>
                  </Label>
                  
                  <div style={{ position: 'relative' }}>
                    <Controller
                      name="assurance_amount"
                      control={control}
                      rules={{
                        required: t("insurance_amount_required"),
                        validate: value => {
                          const numericValue = Number(value.replace(/\s+/g, ''));
                          if (isNaN(numericValue)) {
                            return 'Veuillez entrer un montant valide';
                          }
                          if (numericValue <= 0) {
                            return t("amount_error");
                          }
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <Input
                          {...field}
                          type="number"
                          placeholder={t("amount_in_euro")}
                          onChange={e => {
                            // Formater automatiquement avec des espaces
                            const value = e.target.value.replace(/\s/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                            field.onChange(value);
                          }}
                          style={{ paddingRight: '40px' }}
                        />
                      )}
                    />
                    <span style={{
                      position: 'absolute',
                      right: '15px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#666',
                      fontWeight: 'bold'
                    }}>
                      €
                    </span>
                  </div>
                  
                  {errors.assurance_amount && (
                    <div style={{ color: 'red', marginTop: '5px' }}>
                      {errors.assurance_amount.message}
                    </div>
                  )}
                  
                  <p style={{ 
                    marginTop: '10px',
                    backgroundColor: '#f8f9fa', 
                    padding: '10px',
                    borderRadius: '8px',
                    fontSize: '0.9rem'
                  }}>
                    <strong>Note :</strong> {t("load_value_option")}
                  </p>
                </FormGroup>
              </div>
            )}

            <ButtonGroup>
                {editingTemplate && (
                    <Button style={{width : isMobile? '50%' : ''}} type="button" variant="secondary" onClick={cancelEdit}>
                        {t("cancel")}
                    </Button>
                )}
                <Button style={{width : isMobile? '50%' : ''}} type="submit" variant="primary">
                    {editingTemplate ? t("update") : t("create_template_button")}
                </Button>
            </ButtonGroup>
        </form>
        </Container>
    );
}

export default MissionTemplateForm;